// CAIA Account Popup (OTP Unified + Stable Cookie + Return URL)
(function () {
  const overlay = document.getElementById("caiaAccountOverlay");
  if (!overlay) return;

  const closeBtn = overlay.querySelector(".caia-close");

  const COOKIE_NAME = "caia_account_popup_hidden";
  const HIDE_DAYS = 7;

  // --- helpers ---
  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);

    // Safer cookie flags
    let cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/; SameSite=Lax`;
    if (location.protocol === "https:") cookie += "; Secure";
    document.cookie = cookie;
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
  }

  function isLoggedIn() {
    return !!window.caiaIsLoggedIn || document.body.classList.contains("customer-logged-in");
  }

  function isAccountPage() {
    return (window.location.pathname || "").startsWith("/account");
  }

  function getReturnTo() {
    // Return to current page unless it's /account* (avoid loops)
    const path = window.location.pathname || "/";
    const search = window.location.search || "";
    if (path.startsWith("/account")) return "/";
    return path + search;
  }

  function setAuthLink(returnTo) {
    const a = overlay.querySelector("[data-caia-auth][data-base]");
    if (!a) return;

    const base = a.getAttribute("data-base");
    if (!base) return;

    const url = new URL(base, window.location.origin);
    url.searchParams.set("return_url", returnTo);

    a.setAttribute("href", url.pathname + "?" + url.searchParams.toString());
  }

  function openPopup(returnOverride = null) {
    if (isLoggedIn()) return;
    if (getCookie(COOKIE_NAME) && !window.caiaForceOpen) return;

    const returnTo = returnOverride || getReturnTo();
    setAuthLink(returnTo);

    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  }

  function closePopup() {
    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    setCookie(COOKIE_NAME, "1", HIDE_DAYS);
    window.caiaForceOpen = false;
  }

  // --- close behaviors ---
  if (closeBtn) closeBtn.addEventListener("click", closePopup);

  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && overlay.classList.contains("is-open")) closePopup();
  });

  // If user clicks Continue with OTP, hide popup for a few days
  overlay.addEventListener("click", (e) => {
    const go = e.target.closest(".caia-btn");
    if (!go) return;
    setCookie(COOKIE_NAME, "1", HIDE_DAYS);
  });

  // --- 1) Auto-open by URL param (?caia_account_popup=1) ---
  (function autoOpenFromParam() {
    const params = new URLSearchParams(window.location.search);
    if (!params.has("caia_account_popup")) return;
    if (isLoggedIn()) return;

    openPopup(); // return to current page (non /account)

    params.delete("caia_account_popup");
    const newQs = params.toString();
    const newUrl = window.location.pathname + (newQs ? "?" + newQs : "");
    window.history.replaceState({}, "", newUrl);
  })();

  // --- 2) Auto show triggers (only logged out, not on /account) ---
  if (!isAccountPage()) {
    let shown = false;

    function safeShow() {
      if (isLoggedIn()) return;
      if (shown) return;
      if (getCookie(COOKIE_NAME)) return;
      shown = true;
      openPopup();
    }

    // delay
    setTimeout(safeShow, 8000);

    // scroll 40%
    function onScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight > 0 && scrollTop / docHeight > 0.4) {
        safeShow();
        window.removeEventListener("scroll", onScroll);
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true });

    // exit intent (desktop)
    document.addEventListener("mouseout", (e) => {
      if (window.innerWidth < 768) return;
      if (e.clientY <= 0) safeShow();
    });
  }

  // --- 3) Header account icon behavior ---
  // Logged out -> open popup; after OTP go to /account (your requirement)
  document.addEventListener("click", (e) => {
    const link = e.target.closest("a");
    if (!link) return;

    if (link.closest("#caiaAccountOverlay")) return;

    const trigger = link.closest(".caia-account-trigger");
    if (!trigger) return;

    if (isLoggedIn()) return;

    e.preventDefault();
    window.caiaForceOpen = true;

    // When user explicitly clicks account icon, land them at /account after OTP
    openPopup("/account");
  });
})();